import { OneplatformApiProvider } from '@tbitop/oneplatform-api';
import { ModalContent, ModalHeader } from '@tbitop/ui';
import { environment } from '../../environments/environment';
import { useVersions } from '../../infrastructure/graphql';
import { Versionsanzeige } from './versionsanzeige';

export const AppInfo = ({ onClose }: {onClose: () => void}) => {
  const { apiVersion, clientVersion } = useVersions();

  return (
    <>
      <ModalHeader title="App Informationen" onClose={onClose}/>
      <ModalContent>
        <Versionsanzeige
          logoUrl="/assets/images/sales-planner.svg"
          organisation="Team Beverage"
          appName="Sales Planner"
          clientVersion={clientVersion}
          apiVersion={apiVersion} />
        <div className="text-sm mx-7">
          <div>Team Beverage AG</div>
          <div>Flughafenallee 15</div>
          <div>28199 Bremen</div>
          <div>© 2022 Team Beverage AG. Alle Rechte vorbehalten.</div>
        </div>
        <OneplatformApiProvider
          apiUrl={environment.opGraphQLEndpoint}
        >
        </OneplatformApiProvider>
      </ModalContent>
    </>
  );
};
